import { buildDateFromISOString } from '../../utils/time';
import { displayShortDate } from '../../utils/Format/Format';

const listOfQuartersFirstMonths = [3, 6, 9, 0];
const aprilEnd2024 = new Date('2024-04-29');

const toSelectableDateString = (date) => {
    const fullYear = date.getFullYear();
    const rawMonth = date.getMonth() + 1;
    const rawDay = date.getDate();

    const month = rawMonth < 10 ? `0${rawMonth}` : rawMonth;
    const day = rawDay < 10 ? `0${rawDay}` : rawDay;

    return `${fullYear}-${month}-${day}`;
};

export const calculateMostRecentEndOfMonth = (firstSelectableDate) => {
    const today = new Date();

    const daysToSubtract = listOfQuartersFirstMonths.includes(today.getMonth())
        ? 14
        : 29;
    const mostRecentEndOfMonth = new Date(
        today.setDate(today.getDate() - daysToSubtract)
    );
    mostRecentEndOfMonth.setDate(1);
    mostRecentEndOfMonth.setDate(mostRecentEndOfMonth.getDate() - 1);

    if (!firstSelectableDate) {
        return toSelectableDateString(mostRecentEndOfMonth);
    }

    const firstDateObj = buildDateFromISOString(firstSelectableDate);
    const viewableDateObj =
        firstDateObj < mostRecentEndOfMonth
            ? firstDateObj
            : mostRecentEndOfMonth;

    return toSelectableDateString(viewableDateObj);
};

export const getDropdownDates = (
    isMonthly,
    inceptionDate,
    firstSelectableDate,
    defaultMonths = 23
) => {
    const dropdownDates = [];

    const firstDateObj = new Date(firstSelectableDate);
    // const firstDateObj = new Date(
    //     firstDateObjLocal.getTime() - (firstDateObjLocal.getTimezoneOffset() * 60000)
    // );

    const twoYearsAgo = new Date(firstDateObj.toDateString());
    twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);

    const inceptionDateObj = new Date(inceptionDate);

    dropdownDates.push({
        value: firstDateObj.toISOString(),
        label: displayShortDate(firstDateObj)
    });
    let currMonth = firstDateObj.getMonth();
    let currYear = firstDateObj.getFullYear();

    for (let i = 0; i < defaultMonths; i++) {
        const monthEndDateLocal = new Date(currYear, currMonth, 0);
        const monthEndDate = new Date(
            monthEndDateLocal.getTime() -
                monthEndDateLocal.getTimezoneOffset() * 60000
        );
        const monthsToSubtract =
            isMonthly && monthEndDate.getTime() < aprilEnd2024.getTime()
                ? 3
                : 1;

        if (
            (inceptionDate &&
                inceptionDateObj.getTime() > monthEndDate.getTime()) ||
            monthEndDate.getTime() < twoYearsAgo.getTime()
        ) {
            break;
        }

        dropdownDates.push({
            value: monthEndDate.toISOString(),
            label: displayShortDate(monthEndDate)
        });

        currMonth -= monthsToSubtract;

        if (currMonth <= 0) {
            currMonth = 12 + currMonth;
            currYear -= 1;
        }
    }

    return dropdownDates;
};
